import {
    TAGS_OPEN_CREATE_EDIT_MODAL,
    TAGS_SAVE_TAG,
    TAGS_SAVE_TAG_RESPONSE,
    TAGS_GET_TAG,
    TAGS_GET_TAG_RESPONSE,
    TAGS_GET_ENTITIES,
    TAGS_GET_ENTITIES_RESPONSE,
    CLEAR_REDUX
} from "Redux/actionTypes";

const INITIAL_STATE = {
    openCreateEdit: false,
    id: null,
    tag: null,
    loadingTag: false,
    loadingCreateEdit: false,
    response: null,
    units: [],
    accounts: [],
    loadingEntities: false,
    disabledEntities: false
};

export default (state = INITIAL_STATE, action) => {
    const keys = {
        "Unit": "units",
        "Company": "accounts"
    };

    switch (action.type) {

        case TAGS_OPEN_CREATE_EDIT_MODAL:
            return {
                ...state,
                openCreateEdit: action.payload?.open,
                id: action.payload?.id,
                disabledEntities: action.payload?.disabledEntities
            };

        case TAGS_SAVE_TAG:
            return {
                ...state,
                loadingCreateEdit: true,
                response: null
            };

        case TAGS_SAVE_TAG_RESPONSE:
            return {
                ...state,
                loadingCreateEdit: false,
                response: action.payload?.data,
            }

        case TAGS_GET_TAG:
            return {
                ...state,
                tag: null,
                loadingTag: true
            };

        case TAGS_GET_TAG_RESPONSE:
            return {
                ...state,
                //id: null,
                tag: action.payload?.data,
                loadingTag: false
            };

        case TAGS_GET_ENTITIES:
            return {
                ...state,
                loadingEntities: true
            };

        case TAGS_GET_ENTITIES_RESPONSE:
            return {
                ...state,
                [keys[action.payload?.response?.entityName]]: action.payload?.response?.items,
                loadingEntities: false
            };

        case CLEAR_REDUX:
            return ["", "TAGS_CREATE_EDIT"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INITIAL_STATE }
                : { ...state };

        default:
            return state;
    }
};